import { render, staticRenderFns } from "./ClientSummary.vue?vue&type=template&id=475e6e9b&scoped=true&"
import script from "./ClientSummary.vue?vue&type=script&lang=js&"
export * from "./ClientSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e6e9b",
  null
  
)

export default component.exports